/* notifications.js */

const subscriptions = {};


/* subscribe */
export function subscribe(channel, onPull, pullInterval) {
    const subscription = new Subscription(channel, onPull, pullInterval);
    if (!subscriptions.hasOwnProperty(channel))
        subscriptions[channel] = [];
    subscriptions[channel].push(subscription);
    return subscription;
};


/* push */
export function push(channel, message, source) {
    if (subscriptions.hasOwnProperty(channel))
        subscriptions[channel].forEach(
            subscription => subscription.push(message, source)
        );
};


/* Subscription */
class Subscription {

    constructor(channel, onPull, pullInterval) {
        this.channel = channel;
        this.onPull = onPull;
        this.pullInterval = pullInterval ? pullInterval : 0;
        this.pool = [];
        this.timer = null;
        this.busy = false;
    }
    
    push(message, source) {
        if (!this.pullInterval) {
            this.onPull({ message: message, source: source });
        }
        else {
            this.pool.push({ message: message, source: source });
            this.pull();
        }
    }

    pull() {
        if (!this.busy) {
            this.busy = true;
            const detail = this.pool.shift();
            this.onPull(detail);
            this.timer = setTimeout(() => this.next(), this.pullInterval);
        }
    }
    
    send() {
        const detail = this.pool.shift();
        this.onPull(detail);
        this.timer = setTimeout(() => this.next(), this.pullInterval);
    }

    next() {
        if (this.timer)
            clearTimeout(this.timer);
        this.timer = null;
        if (this.pool.length) {
            this.pull();
        }
        else {
            this.busy = false;
        }
    }
    
    close() {
        if (this.timer)
            clearTimeout(this.timer);
        this.timer = null;
        this.pool.splice(0, this.pool.length);
        subscriptions[this.channel].splice(subscriptions[this.channel].indexOf(this), 1);
    }

}
